import { render, staticRenderFns } from "./PrivacyPolicyContent.vue?vue&type=template&id=051f3f2e&scoped=true&"
import script from "./PrivacyPolicyContent.vue?vue&type=script&lang=js&"
export * from "./PrivacyPolicyContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051f3f2e",
  null
  
)

export default component.exports